// Form-field behaviour shared by every capex request type's *-request-elements.js. Each
// type still owns its own dropdown wiring and any fields beyond this common cost block.

export const updateTotals = () => {
    const $basePrice = $('[name="BasePrice"]');
    const $freight = $('[name="Freight"]');
    const $installation = $('[name="Installation"]');
    const $other = $('[name="OtherAmount"]');
    const $salesTax = $('[name="SalesTax"]');

    const $total = $('[name="CostTotal"]');
    const $budget = $('[name="Budget"]');
    const $netDiff = $('[name="NetDifference"]');

    //Calculate Total
    let total = 0;
    if ($basePrice.length) total += Number($basePrice.val());
    if ($freight.length) total += Number($freight.val());
    if ($installation.length) total += Number($installation.val());
    if ($other.length) total += Number($other.val());
    if ($salesTax.length) total += Number($salesTax.val());

    //Set Totals
    $total.text(kendo.format('{0:C2}', total));
    $netDiff.text(kendo.format('{0:C2}', total - Number($budget.val())));
}

export const bindCostFieldsToUpdateTotals = () => {
    ['BasePrice', 'Freight', 'Installation', 'OtherAmount', 'SalesTax', 'Budget'].forEach((name) => {
        const $field = $(`[name="${name}"]`);
        if ($field) $field.bind('change', updateTotals);
    });
}

export const initDatePickers = () => {
    try {
        const rd = $('.js-datepicker');
        rd.kendoDatePicker({
            format: 'MM/dd/yyyy'
        });
        return true;
    } catch (e) {
        return Promise.reject(e);
    }
}

export const createAccountForDepreciationAutocomplete = (baseUrl) => {
    $('.autocomplete').kendoAutoComplete({
        dataSource: {
            schema: {
                autoSync: true,
                id: 'id',
                fields: {
                    id: {
                        type: 'number'
                    },
                    accountNumber: {
                        type: 'string'
                    }
                }
            },
            transport: {
                read: {
                    dataType: 'json',
                    type: 'GET',
                    url: `${baseUrl}/AccountForDepreciation`
                }
            }
        },
        dataTextField: 'accountNumber',
        dataValueField: 'accountNumber',
        filter: 'contains',
        placeholder: 'Find an account...',
        noDataTemplate: 'No matching accounts found.',
    }).data('kendoAutoComplete');
}
